import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import api from '../services/api';

const initialState = {
  user: null,
  isAuthenticated: false,
  isLoading: false,
  error: null,
};

const useAuthStore = create(
  persist(
    (set, get) => ({
      ...initialState,

      login: async (credentials) => {
        set({ isLoading: true, error: null });
        try {
          const response = await api.post('/auth/signin', credentials);
          const { accessToken, data } = response.data;
          
          localStorage.setItem('token', accessToken);
          
          set({ 
            user: data, 
            isAuthenticated: true, 
            isLoading: false,
            error: null 
          });
          
          return response.data;
        } catch (error) {
          set({ 
            ...initialState,
            error: error.response?.data?.message || 'Login failed'
          });
          throw error;
        }
      },

      register: async (userData) => {
        set({ isLoading: true, error: null });
        try {
          const response = await api.post('/auth/signup', userData);
          set({ isLoading: false, error: null });
          return response.data;
        } catch (error) {
          set({ 
            isLoading: false,
            error: error.response?.data?.message || 'Registration failed'
          });
          throw error;
        }
      },

      logout: () => {
        localStorage.removeItem('token');
        set(initialState);
      },

      checkAuth: async () => {
        const token = localStorage.getItem('token');
        if (!token) {
          set(initialState);
          return false;
        }

        try {
          const response = await api.get('/auth/me');
          set({ 
            user: response.data, 
            isAuthenticated: true,
            error: null
          });
          return true;
        } catch (error) {
          localStorage.removeItem('token');
          set(initialState);
          return false;
        }
      },

      resetAuth: () => {
        set(initialState);
      }
    }),
    {
      name: 'auth-storage',
      storage: createJSONStorage(() => localStorage),
      partialize: (state) => ({
        user: state.user,
        isAuthenticated: state.isAuthenticated
      }),
      onRehydrateStorage: () => (state) => {
        const token = localStorage.getItem('token');
        if (!token) {
          state?.resetAuth();
        }
      }
    }
  )
);

export default useAuthStore; 